<div class="up-bar" fxShow="true" fxHide.lt-md>
  <ng-container *ngFor="let m of menu">
    <ng-container *ngIf="m.type !== 'section'">
      <button
        *ngIf="m.show && (!m.children || m.children.length === 0)"
        class="menu-button"
        mat-button
        [routerLink]="m.routerLink"
        [disabled]="!m.enable">
        {{ m.text }}
      </button>
      <app-sub-menu-up-bar
        *ngIf="m.show && m.children && m.children.length > 0"
        [menu]="m">
      </app-sub-menu-up-bar>
    </ng-container>
  </ng-container>
</div>
